import { ICategorySoldProducts } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'

const generatePSTranslateKey = (translation: string) => {
  return getFormedEltTranslation(`sold-ps-category-${translation}`)
}
const generatePSItemTranslateKey = (translation: string) => {
  return getFormedEltTranslation(`sold-ps-category-item-${translation}`)
}
const generatePrintTranslateKey = (translation: string) => {
  return getFormedEltTranslation(`sold-print-category-${translation}`)
}
const generatePrintItemTranslateKey = (translation: string) => {
  return getFormedEltTranslation(`sold-print-category-item-${translation}`)
}
const generateSuppliesTranslateKey = (translation: string) => {
  return getFormedEltTranslation(`sold-supplies-category-${translation}`)
}
const generateSuppliesItemTranslateKey = (translation: string) => {
  return getFormedEltTranslation(`sold-supplies-category-item-${translation}`)
}

export const psSoldItems: ICategorySoldProducts[] = [
  {
    Key: 'Consumer',
    Name: generatePSTranslateKey('consumer'),
    Products: [
      { Key: 'Notebook', Name: generatePSItemTranslateKey('notebook') },
      { Key: 'Desktops', Name: generatePSItemTranslateKey('desktops') },
    ],
  },
  {
    Key: 'Commercial',
    Name: generatePSTranslateKey('commercial'),
    Products: [
      { Key: 'Notebook', Name: generatePSItemTranslateKey('notebook') },
      { Key: 'Desktops', Name: generatePSItemTranslateKey('desktops') },
      { Key: 'Collaboration/Poly', Name: generatePSItemTranslateKey('collaboration-poly') },
    ],
  },
  {
    Key: 'Workstations',
    Name: generatePSTranslateKey('workstations'),
    Products: [
      { Key: 'Notebook', Name: generatePSItemTranslateKey('notebook') },
      { Key: 'Desktops', Name: generatePSItemTranslateKey('desktops') },
    ],
  },
  {
    Key: 'DisplayDocs',
    Name: generatePSTranslateKey('display-docs'),
    Products: [],
  },
  {
    Key: 'Peripherals',
    Name: generatePSTranslateKey('peripherals'),
    Products: [
      { Key: 'HyperX', Name: generatePSItemTranslateKey('hyper-x') },
      { Key: 'Poly', Name: generatePSItemTranslateKey('poly') },
      { Key: 'HPBranded', Name: generatePSItemTranslateKey('hp-branded') },
    ],
  },
]

export const printSoldItems: ICategorySoldProducts[] = [
  {
    Key: 'HomeAndMicro',
    Name: generatePrintTranslateKey('home-and-micro'),
    Products: [
      { Key: 'InkJet', Name: generatePrintItemTranslateKey('ink-jet') },
      { Key: 'Tanks', Name: generatePrintItemTranslateKey('tanks') },
      { Key: 'Solutions', Name: generatePrintItemTranslateKey('solutions') },
    ],
  },
  {
    Key: 'Office',
    Name: generatePrintTranslateKey('office'),
    Products: [
      { Key: 'A3A4Laser', Name: generatePrintItemTranslateKey('a3-a4') },
      { Key: 'OfficeJet', Name: generatePrintItemTranslateKey('office-jet') },
      { Key: 'Scanjet', Name: generatePrintItemTranslateKey('scan-jet') },
    ],
  },
  {
    Key: 'LargeFormat',
    Name: generatePrintTranslateKey('large-format'),
    Products: [
      { Key: 'LFDesignPro', Name: generatePrintItemTranslateKey('lf-design-pro') },
      { Key: 'IndustrialPrint', Name: generatePrintItemTranslateKey('industrial-print') },
    ],
  },
  {
    Key: '3D',
    Name: generatePSTranslateKey('3-d'),
    Products: [],
  },
]

export const servicesSoldItems: ICategorySoldProducts[] = [
  {
    Key: 'ConsumerSubscriptions',
    Name: generatePSTranslateKey('consumer-subscriptions'),
    Products: [],
  },
  {
    Key: 'Services',
    Name: generateSuppliesTranslateKey('services'),
    Products: [
      { Key: 'LifecycleServices', Name: generateSuppliesItemTranslateKey('lifecycle-services') },
      {
        Key: 'ManagedPrintServices',
        Name: generateSuppliesItemTranslateKey('managed-print-services'),
      },
      { Key: 'DaaS', Name: generateSuppliesItemTranslateKey('daas') },
    ],
  },
  {
    Key: 'Software',
    Name: generateSuppliesTranslateKey('software'),
    Products: [
      { Key: 'SecuritySW', Name: generateSuppliesItemTranslateKey('security') },
      { Key: 'TeradiciSW', Name: generateSuppliesItemTranslateKey('teradici') },
      { Key: 'Print SW', Name: generateSuppliesItemTranslateKey('print') },
    ],
  },
]
